/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MissingInfoFollowUp } from './MissingInfoFollowUp';
import {
    MissingInfoFollowUpFromJSON,
    MissingInfoFollowUpFromJSONTyped,
    MissingInfoFollowUpToJSON,
    MissingInfoFollowUpToJSONTyped,
} from './MissingInfoFollowUp';

/**
 * 
 * @export
 * @interface EditMissingInfoFollowUpDraft200Response
 */
export interface EditMissingInfoFollowUpDraft200Response {
    /**
     * 
     */
    data: MissingInfoFollowUp;
}

/**
 * Check if a given object implements the EditMissingInfoFollowUpDraft200Response interface.
 */
export function instanceOfEditMissingInfoFollowUpDraft200Response(value: object): value is EditMissingInfoFollowUpDraft200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function EditMissingInfoFollowUpDraft200ResponseFromJSON(json: any): EditMissingInfoFollowUpDraft200Response {
    return EditMissingInfoFollowUpDraft200ResponseFromJSONTyped(json, false);
}

export function EditMissingInfoFollowUpDraft200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMissingInfoFollowUpDraft200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MissingInfoFollowUpFromJSON(json['data']),
    };
}

export function EditMissingInfoFollowUpDraft200ResponseToJSON(json: any): EditMissingInfoFollowUpDraft200Response {
    return EditMissingInfoFollowUpDraft200ResponseToJSONTyped(json, false);
}

export function EditMissingInfoFollowUpDraft200ResponseToJSONTyped(value?: EditMissingInfoFollowUpDraft200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MissingInfoFollowUpToJSON(value['data']),
    };
}

